import { useEffect, useState } from "react";

import Loading from "@/components/ui/loading";
import { Button, Modal, Table } from "react-bootstrap";

import api from "@/lib/api";

type ItemModalProps = {
  itemId: number;
  itemIndex: number;
  items: { value: number }[];
  showItemModal: boolean;
  handleCloseItemModal: () => void;
  setItemModal: React.Dispatch<React.SetStateAction<boolean>>;
  setModuleModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDatasetModal: React.Dispatch<React.SetStateAction<boolean>>;
  setItemId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setItemIndex: React.Dispatch<React.SetStateAction<number>>;
};

type ItemModalData = {
  dataset: {
    value: string;
    label: string;
  };
  module: {
    value: string;
    label: string;
  };
  item: {
    value: number;
    label: string;
    description: string;
    item_type_title: string;
    answer_type_title: string;
    choice_text: string;
  };
};

export async function getItemModalData(item_id: number) {
  try {
    const response = await api.get<ItemModalData>(`/hrd/item/${item_id}`);
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data");
  }
}

export default function ItemModal({
  itemId,
  showItemModal,
  itemIndex,
  items,
  handleCloseItemModal,
  setItemModal,
  setModuleModal,
  setDatasetModal,
  setItemId,
  setItemIndex,
}: ItemModalProps) {
  const [itemData, setItemData] = useState<ItemModalData>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (itemId) {
        setLoading(true);
        const response = await getItemModalData(itemId);
        setItemData(response);
        setLoading(false);
      }
    };
    fetchData();
  }, [showItemModal, itemId]);

  const handleNextItem = () => {
    const nextIndex = itemIndex + 1;
    if (nextIndex < items.length) {
      setItemIndex(nextIndex);
      setItemId(items[nextIndex].value);
    }
  };

  const handlePrevItem = () => {
    const prevIndex = itemIndex - 1;
    if (prevIndex >= 0) {
      setItemIndex(prevIndex);
      setItemId(items[prevIndex].value);
    }
  };

  return (
    <>
      <Modal show={showItemModal} onHide={handleCloseItemModal} size="lg" aria-labelledby="item-modal">
        <Modal.Header closeButton>
          <Modal.Title className="g2-text-grey">{itemData?.item?.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Loading />
          ) : (
            <>
              <p>
                <span className="g2-text-grey">
                  <span
                    className="g2-link-blue"
                    onClick={() => {
                      handleCloseItemModal();
                    }}
                  >
                    Harmonized Data
                  </span>{" "}
                  &gt;{" "}
                  <span
                    className="g2-link-blue"
                    onClick={() => {
                      setItemModal(false);
                      setModuleModal(false);
                      setDatasetModal(true);
                    }}
                  >
                    {itemData?.dataset.label}
                  </span>{" "}
                  &gt;{" "}
                  <span
                    className="g2-link-blue"
                    onClick={() => {
                      setItemModal(false);
                      setDatasetModal(false);
                      setModuleModal(true);
                    }}
                  >
                    {itemData?.module.label}
                  </span>{" "}
                  &gt; <span>{itemData?.item.label}</span>
                </span>
              </p>
              <Table bordered striped responsive width="100%">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{ width: "25%" }}>
                      Label:
                    </td>
                    <td>{itemData?.item.label || "-"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold" style={{ width: "25%" }}>
                      Description:
                    </td>
                    <td>{itemData?.item.description || "-"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold" style={{ width: "25%" }}>
                      Item type:
                    </td>
                    <td>{itemData?.item.item_type_title || "-"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold" style={{ width: "25%" }}>
                      Answer type:
                    </td>
                    <td>{itemData?.item.answer_type_title || "-"}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold" style={{ width: "25%" }}>
                      Answer choices:
                    </td>
                    <td>{itemData?.item.choice_text || "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {itemIndex !== 0 && (
            <Button className="g2-btn-blue" onClick={handlePrevItem}>
              Previous
            </Button>
          )}
          {itemIndex !== items.length - 1 && (
            <Button className="g2-btn-blue" onClick={handleNextItem}>
              Next
            </Button>
          )}
          <Button variant="secondary" onClick={handleCloseItemModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
